import { render, staticRenderFns } from "./GameGenreProblems.vue?vue&type=template&id=4d009f82"
import script from "./GameGenreProblems.vue?vue&type=script&lang=js"
export * from "./GameGenreProblems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports